import { version, memo, forwardRef, Component, useCallback, createElement, useEffect } from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

/**
 * 记录组件使用情况
 *
 */

var LogType;

(function (LogType) {
  // 组件渲染
  LogType["RENDERED"] = "RENDERED"; // 其他自定义的错误类型

  LogType["CUSTOM"] = "CUSTOM"; // 组件内部错误

  LogType["ERROR"] = "ERROR";
})(LogType || (LogType = {}));

var baseData = {
  // @ts-ignore
  version: "4.16.6",
  reactVersion: version
};
var tracker = null;
var setTracker = function setTracker(Tracker) {
  if (typeof (Tracker == null ? void 0 : Tracker.log) === 'function') {
    tracker = Tracker;
  }
};
var getTracker = function getTracker() {
  var _tracker;

  if (typeof ((_tracker = tracker) == null ? void 0 : _tracker.log) === 'function') {
    return tracker;
  } // 默认模拟一个空函数


  return {
    log: function log() {}
  };
};

var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ErrorBoundary, _React$Component);

  function ErrorBoundary() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ErrorBoundary.prototype;

  _proto.componentDidCatch = function componentDidCatch(error) {
    var _this$props$onError, _this$props;

    (_this$props$onError = (_this$props = this.props).onError) == null ? void 0 : _this$props$onError.call(_this$props, error);
  };

  _proto.render = function render() {
    return this.props.children;
  };

  return ErrorBoundary;
}(Component);

function withError(BaseComponent, options) {
  var C = function C(props, ref) {
    var handleError = useCallback(function (error) {
      var _error$message;

      getTracker().log(BaseComponent.displayName, _extends({}, baseData, {
        type: LogType.ERROR,
        c1: (_error$message = error == null ? void 0 : error.message) != null ? _error$message : 'unknown error'
      })); // 这个错误再抛给上层，免得外层捕获不到错误了

      throw error;
    }, []);
    var forwardRefProps = options != null && options.forwardRef ? {
      forwardRef: ref
    } : {};
    return createElement(ErrorBoundary, {
      onError: handleError
    }, createElement(BaseComponent, Object.assign({}, props, forwardRefProps)));
  };

  var memoComponent;

  if (options != null && options.forwardRef) {
    memoComponent = memo(forwardRef(C));
  } else {
    memoComponent = memo(C);
  }

  hoistNonReactStatics(memoComponent, BaseComponent);
  memoComponent.displayName = BaseComponent.displayName;
  return memoComponent;
}

var useTracker = (function (component, c1) {
  if (component === void 0) {
    component = 'UNKNOWN';
  }

  var tracker = getTracker();

  var data = _extends({}, baseData, {
    type: LogType.RENDERED
  }, c1 ? {
    c1: c1
  } : {});

  useEffect(function () {
    tracker.log(component, data);
  }, []); // 返回的函数执行会上报 data.type=CUSTOM 的数据

  return function (ext) {
    return tracker.log(component, _extends({}, data, {
      type: LogType.CUSTOM
    }), ext);
  };
});

export { ErrorBoundary, getTracker, setTracker, useTracker, withError };
//# sourceMappingURL=tracker.esm.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/tracker/dist/tracker.esm.js
// module id = 16
// module chunks = 0